import React from "react";
import { Grid, Header, Segment, Button, Icon } from "semantic-ui-react";
import { injectIntl, FormattedMessage } from "gatsby-plugin-intl";
import Layout from "../../components/Layout";
import ContactForm from "../../components/forms/ContactForm";
import { Block } from "../../components/StyledComponent";

const RefundPage = ({ intl }) => (
  <Layout>
    <Block
      title={intl.formatMessage({ id: "section_refund" })}
      color="gray"
      textAlign="center"
    >
      <p>We are committed to ensuring your satisfaction with our product.</p>
      If, for any reason, the software does not meet your expectations, you may
      return it within <b>14 days</b> of the purchase date for a full refund of
      the product price.
    </Block>
    <Block>
      <p>
        Please complete the form below to submit your return request. Once your
        request is processed, you will receive an email confirmation. Kindly
        allow 5-7 business days for the credit to reflect on your statement.
        Please ensure the product is uninstalled from your computer before we
        issue the refund.
      </p>
      <p style={{ marginBottom: "4em" }}>
        If you purchased the software through one of our resellers or
        affiliates, please reach out to them directly to process your return. We
        can only accept returns for products purchased directly from our
        website.
      </p>
      <Grid container stackable>
        <Grid.Column width={11}>
          <Header as="h4" attached="top" block>
            <FormattedMessage id="contact_us" />
          </Header>
          <Segment attached style={{ padding: "1.5em" }}>
            <ContactForm defaultCategory="sales" />
          </Segment>
        </Grid.Column>
        <Grid.Column floated="right" width={5}>
          <Header as="h4" attached="top" block>
            <FormattedMessage id="contact_email" />
          </Header>
          <Segment attached style={{ padding: "1.5em" }}>
            <p>
              <FormattedMessage
                id="contact_email_at"
                values={{
                  email: "contact@picpick.app",
                }}
              />
            </p>
            <Button
              as="a"
              href="mailto:contact@picpick.app"
              primary
              size="big"
              content={intl.formatMessage({ id: "contact_email_send" })}
            />
          </Segment>
        </Grid.Column>
      </Grid>
    </Block>
  </Layout>
);

export default injectIntl(RefundPage);
